// extracted by mini-css-extract-plugin
export default {"overlay":"rgba(51, 51, 51, .5)","gray02":"#D8DDE1","backdrop":"SideBarNavLight__backdrop___+codn","menu":"SideBarNavLight__menu___pO0GF","modal":"SideBarNavLight__modal___hKlzE"};